import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class ListCategories {
    constructor() {
        this.slider = document.querySelector('.swiper--component-list-categories');

        this.navigationPrev = document.querySelector('.slider-button-prev--component-list-categories');
        this.navigationNext = document.querySelector('.slider-button-next--component-list-categories');

        this.titleLocal = document.querySelector('#category-super-label');

        this.ready();
    }

    ready() {
        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        const spaceBetween = 24;
        const maxSlideWidth = 360;

        if (isDesktop) {
            this.slider.setAttribute('dir', 'rtl');
        } else {
            this.slider.setAttribute('dir', 'ltr');
        }

        const calcSlidesPerView = (width) => {
            const minSlides = window.innerWidth >= 1580 ? 3.2 : 2.3;
            if (!width) {
                return minSlides;
            }

            return Math.max(minSlides, (width + spaceBetween) / (maxSlideWidth + spaceBetween));
        };

        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            loop: true,
            rtl: isDesktop,
            grabCursor: true,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                0: {
                    loop: false,
                    rtl: false,
                    slidesPerView: 1.5,
                    spaceBetween: 24,
                    slidesOffsetBefore: 32,
                    slidesOffsetAfter: 32,
                },
                1024: {
                    loop: true,
                    rtl: true,
                    slidesPerView: 2.3,
                    spaceBetween: 24,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
            },
            // on: {
            //     init: (swiper) => {
            //         if(this.slider.querySelector('.swiper-slide-next')) {
            //             const currentTitle = this.slider.querySelector('.swiper-slide-active').dataset.title
            //             this.navigationPrevName.innerHTML = currentTitle
            //             const nextTitle = this.slider.querySelector('.swiper-slide-next').dataset.title
            //             this.navigationNextName.innerHTML = nextTitle
            //         }
            //     },
            // },
        });

        const syncSlidesPerView = () => {
            if (!window.matchMedia('(min-width: 1024px)').matches) {
                return;
            }

            const slidesPerView = Math.round(calcSlidesPerView(swiper.width) * 100) / 100;

            if (swiper.params.slidesPerView === slidesPerView) {
                return;
            }

            swiper.params.slidesPerView = slidesPerView;
            if (swiper.params.breakpoints?.[1024]) {
                swiper.params.breakpoints[1024].slidesPerView = slidesPerView;
            }
            swiper.update();
        };

        syncSlidesPerView();
        swiper.on('resize', syncSlidesPerView);

        if (this.titleLocal) {
            swiper.on('activeIndexChange', () => {
                const activeSlide = this.slider.querySelector('.swiper-slide-active a');
                if (activeSlide?.dataset.titulo) {
                    this.titleLocal.innerHTML = activeSlide.dataset.titulo;
                }
            });
        }
    }
}
if (document.querySelector('.components-list-categories')) {
    new ListCategories();
}
